<script>
	
	import { fly } from 'svelte/transition';
	import { quintInOut } from 'svelte/easing';
	
	import { onMount } from 'svelte';
	
	export let items; 
	export let columnWidth = 400;
	
	let gridWidth;         
	let columns = [];
	let columnCount;
	let gridElement;
	let interval;
	let limit = 0;
	let ready = false;

	function selectColumn( i ){
		if( i <= (columnCount * 3) ){
			// left to right order
			return i % columnCount;
		}
		// select smalles column
		let columns = gridElement.querySelectorAll('.column-inner');
		let columnHeights = [];
		columns.forEach( (col, i) => {
			columnHeights[i] = col.offsetHeight;
		});
		let smallestValue = Math.min(...columnHeights);
		return columnHeights.indexOf( smallestValue );
	}
	
	function appendNextItem( i ){
		let selectedColumn = selectColumn();
		let nextItem = items[i];
		// try {
		// 	let id = nextItem.id;
		// } catch (err) {
		// 	console.error( 'no id', err,
		// 		{ nextItem, limit, length: items.length, items },
		// 	);
		// }
		columns[selectedColumn].items.push( nextItem );
		columns = columns;
	}

	function clearColumns(){
		clearInterval( interval );
		columns = Array.from(Array(columnCount)).map(n => {
			return {
				height: 0,
				items: [],
			};
		});
	}
	
	async function renderColumns(){
		if( !ready ){ return; }

		clearColumns();

		let i = 0;
		interval = setInterval(()=>{
			if( !gridElement ){
				clearInterval( interval );
				return;
			}
			appendNextItem( i );
			i++;
			if( i >= items.length ){
				clearInterval( interval );
			};
		}, 100);
	}
	
	function newColumnsCount( c ){
		if( !c || c === columnCount ){ return; }

		columnCount = c;
		renderColumns();     
	}
	
	onMount(async()=>{
		ready = true;
		renderColumns();
		return () => {
			clearInterval( interval );
		};
	});
	
	$: renderColumns( items );
 	
	$: newColumnsCount( Math.ceil( gridWidth / columnWidth ) );
	
	const trans = {
		duration: 500,
		delay: 0,
		opacity: 0,
		x: 0,
		y: 100,
		easing: quintInOut
	};
	
</script>

<ul class="grid" bind:clientWidth={gridWidth} bind:this={gridElement}>
	{#each columns as column, c}
		<div class="column">
			<div class="column-inner">
				{#each column.items as item (item.id)}
					<li in:fly="{trans}" >
						<slot prop={item} />
					</li>
				{/each}
			</div>
		</div>
	{/each}
</ul>

<style>
	
	.grid {
		display: flex;
	}
	
	.column {
		flex: 1;
		padding-right: 1rem;
	}
	
</style>


